
export const getStatusVariant = (status) => {
  if (!status) return 'grey';
  
  const statusLower = status.toLowerCase();
  
  // Success states
  if (['success', 'approved', 'active', 'settled', 'authorized', 'onboarded'].includes(statusLower)) {
    return 'green';
  }
  
  // Warning states  
  if (['pending', 'waiting', 'suspended', 'voided', 'reversed', 'partially_refunded', 'refunded', 'offboarded'].includes(statusLower)) {
    return 'orange';
  }
  
  // Error states
  if (['declined', 'failed', 'rejected', 'cancelled', 'timeout', 'terminated', 'onboard_failed', 'offboard_failed'].includes(statusLower)) {
    return 'red';
  }
  
  // Info states
  if (['open', 'processing'].includes(statusLower)) {
    return 'blue';
  }
  
  // Neutral states
  if (['closed', 'none', 'inactive', 'not_onboarded'].includes(statusLower)) {
    return 'grey';
  }
  
  return 'grey';
};
